import React, { useState } from 'react';
import './PickupForm.css';

const PickupForm: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', email: '', date: '', address: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      const response = await fetch(`${apiBaseUrl}/api/send-pickup-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || 'Unable to submit your request right now.');
      }

      setIsSubmitted(true);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unable to submit your request right now.';
      setSubmitError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="pickup-form">
      {isSubmitted ? (
        <div className="popup">
          <h3>Thank you! Your Tire pickup service request completed successfully. Our team will contact you in 1-2 business days.</h3>
        </div>
      ) : (
        <>
          <h2>Schedule a Tire Pickup</h2>
          <form onSubmit={handleSubmit}>
            <label>Name:
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </label>
            <label>Email:
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </label>
            <label>Pickup Date:
              <input type="date" name="date" value={formData.date} onChange={handleChange} required />
            </label>
            <label>Address:
              <input type="text" name="address" value={formData.address} onChange={handleChange} required />
            </label>
            {submitError && <p>{submitError}</p>}
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Schedule Pickup'}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default PickupForm;
